// 鉴权白名单
// 纯页面路由前缀：命中后 Layout 隐藏 header 与左侧菜单（通用助手页等）。
// beforeEach 用它打 meta.purePage；useLayout 用它在首帧渲染前同步初始化
// （路由 meta 在初始导航确认前是空的，读 meta 会闪一帧常规布局）。
export const PURE_PAGE_PREFIXES = ['/assistant', '/occ/assistant']

// 前缀需整段匹配（`/assistant` 或 `/assistant/...`），避免误吞 `/assistant-foo`
export function isPurePagePath(path: string) {
  return PURE_PAGE_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))
}

export const AUTH_WHITELIST = [
  '/open-app',
  '/500',
  '/error'
]
